
export function isJson(rule, value, callback) {
  let param = {};
  try {
    param = JSON.parse(value);
    if (typeof param === 'object' && param) {
      callback();
    }
    callback(new Error('请填写正确的JSON格式数据'));
  } catch (error) {
    callback(new Error('请填写正确的JSON格式数据'))
  }
}




// WEBPACK FOOTER //
// ./src/assets/js/validator.js